'use client';

import { BoxCTA } from '@lichtblick/photon/atoms/box-cta/box-cta';
import { Headline } from '@lichtblick/photon/atoms/headline/headline';
import { Text } from '@lichtblick/photon/atoms/text/text';
import { Stepper } from '@lichtblick/photon/molecules/stepper';
import { Textfield } from '@lichtblick/photon/molecules/textfield';
import { useTracker } from '@lichtblick/tracker';
import { type ChangeEventHandler, type FC, useCallback, useState } from 'react';
import type { B2bCalculatorElectricityType } from '../../../types/storyblok';
import styles from './calculator.module.scss';

export const B2bCalculatorElectricity: FC<B2bCalculatorElectricityType> = () => {
  const [electricityUsage, setElectricityUsage] = useState<string>();
  const [electricityMeters, setElectricityMeters] = useState(1);

  const { trackCustomEvent } = useTracker();

  const electricityChangeHandler = useCallback<ChangeEventHandler<HTMLInputElement>>(({ currentTarget }) => {
    setElectricityUsage(currentTarget.value);
  }, []);

  return (
    <form
      action="/checkout-b2b/gewerbestrom"
      className={styles.form}
      id="b2b-electricity-calculator"
      method="GET"
      onSubmit={({ currentTarget }) => {
        if (currentTarget.checkValidity()) {
          trackCustomEvent({
            eventName: 'b2b_calculator_show_lead_form',
            customProps: {
              product: 'GewerbeStrom',
              meterCount: electricityMeters,
              consumption_calculator: `${electricityUsage} kWh/Jahr`,
            },
          });
        }
      }}
    >
      <Headline className={styles.headline} renderAs="h2" size="s">
        GewerbeStrom
      </Headline>
      <Stepper defaultValue={1} label="Anzahl Zähler" min={1} onChange={setElectricityMeters} name="zaehler" />
      <Textfield
        label="Stromverbrauch"
        min={0}
        name="strom"
        onChange={electricityChangeHandler}
        rightSlot={
          <Text className={styles.unit} size="s">
            kWh/Jahr
          </Text>
        }
        type="number"
        value={electricityUsage}
      />

      <BoxCTA as="button" type="submit">
        Unverbindlich anfragen
      </BoxCTA>
    </form>
  );
};
